<template>
    <div id="reset-password">
        <ValidationObserver ref="observer">
            <v-form novalidate action="/password/reset" method="post">
                <v-card tile>

                    <v-toolbar color="primary" flat dark>
                        <v-toolbar-title>{{ translations.app_name }} {{ translations.auth.reset_password }}</v-toolbar-title>
                        <div class="flex-grow-1"></div>
                    </v-toolbar>

                    <v-card-text>

                        <v-alert type="error" dismissible v-model="hasError">
                            {{ n_errors[0] }}
                        </v-alert>

                        {{ translations.auth.reset_password_text }}

                        <ValidationProvider rules="required" v-slot="{ errors }" :name="translations.auth.username">
                            <v-text-field
                                :label="translations.auth.username"
                                prepend-inner-icon="fas fa-user"
                                type="text"
                                v-model="input.username"
                                :error-messages="errors[0]"
                                name="username"
                            ></v-text-field>
                        </ValidationProvider>

                        <ValidationProvider rules="required|min:8" v-slot="{ errors }" :name="translations.auth.password" vid="password">
                            <v-text-field
                                :label="translations.auth.password"
                                type="password"
                                prepend-inner-icon="fas fa-lock"
                                v-model="input.password"
                                :error-messages="errors[0]"
                                name="password"
                            ></v-text-field>
                        </ValidationProvider>

                        <ValidationProvider rules="required|min:8|confirmed:password" v-slot="{ errors }" :name="translations.auth.password_confirmation">
                            <v-text-field
                                :label="translations.auth.password_confirmation"
                                type="password"
                                prepend-inner-icon="fas fa-lock"
                                v-model="input.password_confirmation"
                                :error-messages="errors[0]"
                                name="password_confirmation"
                            ></v-text-field>
                        </ValidationProvider>

                        <input type="hidden" name="_token" :value="csrf">
                        <input type="hidden" name="token" :value="token">

                    </v-card-text>

                    <v-card-actions>
                        <v-btn text href="/login">{{ translations.auth.cancel }}</v-btn>
                        <div class="flex-grow-1"></div>
                        <v-btn color="primary" type="submit" @click.native="submit">{{ translations.auth.reset_password }}</v-btn>
                    </v-card-actions>

                </v-card>
            </v-form>
        </ValidationObserver>
    </div>
</template>

<script>
    export default {
        name: "ResetPassword",
        props: {
            username: String,
            token: String,
            trans: String|Object,
            errors: String|Array,
            csrf: String,
        },
        data() {
            return {
                input: {
                    username: '',
                    password: '',
                    password_confirmation: '',
                    token: '',
                },
                translations: {
                    app_name: '',
                    auth: {
                        reset_password: 'Reset Password',
                        reset_password_text: 'Please fill in the fields below to reset your password',
                        login: 'Login',
                        cancel: 'Back to login',
                        username: 'Username',
                        password:  'Password',
                        password_confirmation: 'Confirm Password',
                    },
                    passwords: {
                        token: 'This password reset token is invalid or has expired.',
                    },
                },
                n_errors: [],
            };
        },
        computed: {
            hasError() {
                return this.n_errors.length > 0;
            },
        },
        methods: {
            async submit(event) {
                let valid = await this.$refs.observer.validate();

                if (! valid) {
                    event.preventDefault();
                }
            },
            getTranslations(translations) {
                let key,
                    translated = {};

                if (typeof translations === 'string') {
                    translations = JSON.parse(translations);
                }

                for (key in translations) {
                    if (!translations.hasOwnProperty(key)) {
                        continue;
                    }

                    if (typeof translations[key] !== 'string') {
                        translations[key] = this.getTranslations(translations[key]);
                    }

                    translated[key] = translations[key];
                }

                return translated;
            },
        },
        created() {
            this.input.username = this.username;
            this.input.token = this.token;

            if (typeof this.errors == 'string') {
                this.n_errors = JSON.parse(this.errors);
            } else {
                this.n_errors = this.errors;
            }

            this.translations = this.getTranslations(this.trans);
        },
    };
</script>

<style scoped>

</style>
